import {
  PrintKind,
  PrintStatus,
} from "@redotech/redo-fulfillment-group-common/fulfillment-print-status";
import { FulfillmentGroupActions } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";

const printKindForAction: Partial<Record<FulfillmentGroupActions, PrintKind>> =
  {
    [FulfillmentGroupActions.PRINT_LABEL]: PrintKind.LABEL,
    [FulfillmentGroupActions.PRINT_PACKING_SLIP]: PrintKind.PACKING_SLIP,
    [FulfillmentGroupActions.PRINT_PERSONALIZED_SLIP]:
      PrintKind.PERSONALIZED_SLIP,
    [FulfillmentGroupActions.PRINT_PICK_LIST]: PrintKind.PICK_LIST,
    [FulfillmentGroupActions.PRINT_ORDER_SUMMARY]: PrintKind.ORDER_SUMMARY,
    [FulfillmentGroupActions.PRINT_LOCAL_PICKUP_LABEL]:
      PrintKind.LOCAL_PICK_UP_LABEL,
    [FulfillmentGroupActions.COMMERCIAL_INVOICE]: PrintKind.COMMERCIAL_INVOICE,
    [FulfillmentGroupActions.PRINT_RETURN_LABEL]: PrintKind.RETURN_LABEL,
    [FulfillmentGroupActions.PRINT_BOL]: PrintKind.BILL_OF_LADING,
    [FulfillmentGroupActions.PRINT_PARCEL_PACKING_SLIPS]:
      PrintKind.PARCEL_PACKING_SLIP,
  };

/** "Reprint …" once every selected group has already printed that document. */
export function printActionLabel(
  action: FulfillmentGroupActions,
  fulfillmentGroups: readonly { printStatus?: PrintStatus | null }[],
): string {
  const kind = printKindForAction[action];
  if (
    kind &&
    fulfillmentGroups.length > 0 &&
    fulfillmentGroups.every((group) => group.printStatus?.[kind])
  ) {
    return action.replace(/^Print /, "Reprint ");
  }
  return action;
}
